// File: /src/utils/validators.ts
// Created Date: Friday January 10th 2025
// Author: Christian Nonis <alch.infoemail@gmail.com>
// -----
// Last Modified: Friday January 10th 2025 9:05:36 pm
// Modified By: the developer formerly known as Christian Nonis at <alch.infoemail@gmail.com>
// -----

import { ONBOARDING_STEPS } from "../constants/onboarding";

export const codiceFiscaleValidator = (codiceFiscale: string) => {
  return codiceFiscale?.trim().length === 16;
};

export const telephoneNumberValidator = (telephoneNumber: string) => {
  return telephoneNumber?.trim().length >= 12;
};

export const emailValidator = (email: string) => {
  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
};

export const maggiorenneValidator = (birthDate: Date) => {
  const today = new Date();
  const _birthDate = new Date(birthDate);
  return today.getFullYear() - _birthDate.getFullYear() >= 18;
};

export const haveInvalidFields = (
  obj: Record<string, any>
): [string[], boolean] => {
  const invalidFields: string[] = [];
  for (const key in obj) {
    if (typeof obj[key] === "object") {
      const [_invalidFields, hasInvalidFields] = haveInvalidFields(obj[key]);
      if (hasInvalidFields) {
        invalidFields.push(..._invalidFields);
      }
    } else if (obj[key] !== 0 && !Boolean(obj[key])) {
      invalidFields.push(key);
    }
  }
  return [invalidFields, invalidFields.length > 0];
};

export const isOptional = (key: string) => {
  return !ONBOARDING_STEPS.find((step) =>
    step.key.split(".").some((k) => k === key)
  )?.mandatory;
};
